<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid" v-if="!loading">
            <div class="row">
                <div class="col">
                    <div class="m-b-xs-20">
                        <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                            <div class="ak-panel__header ak-panel__header--small">
                                <h2 class="ak-form__title">
                                    {{ $t('Bepaal verzendkosten en afhaalpunten voor ') }} {{ product.title }}
                                </h2>
                            </div>
                            <div class="ak-panel__body ak-panel__body--small reading">

                                <template v-if="prices">
                                    <ak-price
                                        v-for="price in prices" :key="price.id"
                                        :id="`price-pickup-${price.id}`"
                                        :title="price.label"
                                        :value="price.priceRaw"
                                        @input="onInputPrice($event, price)"
                                    />
                                </template>

                                <div class="ak-form__group" v-if="hasPickupType">
                                    <label class="ak-form__label">Locaties</label>

                                    <div v-for="organisation in organisations" :key="organisation.id">
                                        <ak-form-decorator
                                            :id="organisation.id.toString()"
                                            :value="organisation.checked"
                                        >
                                            <label class="ak-form__checkbox">
                                                <input
                                                    type="checkbox"
                                                    v-model="organisation.checked"
                                                    :checked="organisation.checked"
                                                    @change="onChangeOrganisation(organisation)"
                                                />
                                                <span class="ak-form__checkmark ak-form__checkmark--checkbox"></span>
                                                <span v-html="organisation.label" />
                                            </label>
                                        </ak-form-decorator>
                                        <div v-if="organisation.locations" style="margin-left: 25px;">
                                            <div v-for="location in organisation.locations" :key="location.id">
                                                <ak-form-decorator
                                                    :id="`org-${location.id}`"
                                                    :value="location.checked"
                                                >
                                                    <label class="ak-form__checkbox">
                                                        <input
                                                            type="checkbox"
                                                            v-model="location.checked"
                                                            :checked="location.checked"
                                                            @change="onChangeLocation(organisation, location)"
                                                        />
                                                        <span class="ak-form__checkmark ak-form__checkmark--checkbox"></span>
                                                        <span v-html="location.label" />
                                                    </label>
                                                </ak-form-decorator>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ak-button
                                    colorMode="primary"
                                    @click="submit"
                                >
                                    {{ $t('Verzenden') }}
                                </ak-button>

                                <ak-button
                                    colorMode="ghost"
                                    @click="cancel"
                                    :enableConfirm="true"
                                    :confirmTitle="$t('Ben je zeker?')"
                                    :confirmText="$t('Ben je zeker dat je wil annuleren?')"
                                >
                                    {{ $t('Annuleren') }}
                                </ak-button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ak-loader size="large" :loading="loading" />
    </div>
</template>

<script>
export default {
    name: 'PickupLocation',
    data() {
        return {
            loading: false,
            product: null,
            prices: null,
            organisations: null,
            hasPickupType: false,
        }
    },
    methods: {
        /**
         * Get data
         *
         * @returns {Promise<void>}
         */
        async getData () {
            this.loading = true;
            const result = await this.$get('/product-pickup-location/' + this.$route.params.hashId);
            this.loading = false;

            if (result.success) {
                this.product = result.data.product;
                this.prices = result.data.prices;
                this.organisations = result.data.organisations;
                this.hasPickupType = result.data.hasPickupType;
            }
        },
        /**
         * On change organisation checkbox
         *
         * @param organisation
         */
        onChangeOrganisation (organisation) {
            organisation.locations.forEach(function (location) {
                location.checked = organisation.checked;
            });
        },
        /**
         * On change location
         *
         * @param organisation
         * @param location
         */
        onChangeLocation (organisation, location) {
            if ( ! location.checked) {
                organisation.checked = false;
            }

            let allLocationsChecked = true;
            organisation.locations.forEach(function (location) {
                if ( ! location.checked) {
                    allLocationsChecked = false;
                }
            });

            if (allLocationsChecked) {
                organisation.checked = true;
            }
        },
        /**
         * On input price
         *
         * @param event
         * @param price
         */
        onInputPrice (event, price) {
            price.priceRaw = event;
        },
        /**
         * Submit form
         */
        async submit () {
            this.loading = true;
            const result = await this.$post('/product-pickup-location/submit/' + this.$route.params.hashId, {
                'productId': this.$route.params.hashId,
                'prices': this.prices,
                'organisations': this.organisations,
            });
            this.loading = false;

            if (result.success) {
                this.redirectToGrid();
            }
        },
        /**
         * Cancel form
         */
        cancel () {
            this.redirectToGrid();
        },
        /**
         * Redirect to grid
         */
        redirectToGrid () {
            this.$router.push({name: 'grid', params:{bundle: 'product', gridDefinition: 'grid'}});
        }
    },
    created() {
        this.getData();
    }
}
</script>
